import React from 'react';
import { View } from 'react-native';
import get from 'lodash/get';
import ExpandableGrid from '../../Alerts/components/AlertSummary/ExpandableGrid';
import Pagination from '../../../components/Common/Pagination';
import style from './style';

const RoomRankerTable = ({
  itemData,
  sortReducer,
  sortingInProgress,
  currentPage,
  page_size,
  rawData,
  handleOnSortClick,
  handlePageChange,
  reduxData
}) => {
  const columns = get(itemData, 'columns', []).map((col, index) => ({
    ...col,
    index
  }));

  const tableData = rawData.map((row, index) => {
  const transformedRow = { id: `${index}`, subData: [] };
    columns.forEach(col => {
      transformedRow[col.field] = Array.isArray(row) ? row[col.index] : get(row, col.field, '');
    });
    return transformedRow;
  });
  const totalRecords = get(reduxData, 'totalRecords', 0);
  const totalPages = Math.ceil(totalRecords / page_size);
  return (
    <View style={style.container}>
      <ExpandableGrid
        columns={columns}
        data={tableData}
        sortConfig={sortReducer}
        handleOnSortClick={handleOnSortClick}
        sortingInProgress={sortingInProgress}
      />
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={page_size}
          onPageChange={handlePageChange}
        />
      )}
    </View>
  );
};

export default RoomRankerTable;